import { IconList } from './Icon/tsx';

export const colorWhite = '#FFFFFF';
export const colorBlack = '#222222';

export const colorGray1 = '#F8F8F8';
export const colorGray2 = '#ECECEC';
export const colorGray3 = '#DDDDDD';
export const colorGray4 = '#CCCCCC';
export const colorGray5 = '#ACACAC';
export const colorGray6 = '#777777';
export const colorGray7 = '#616161';
export const colorGray8 = '#444444';

export const colorAqua1 = '#E6FAF9';
export const colorAqua2 = '#86E9E2';
export const colorAqua3 = '#0DD3C5';
export const colorAqua4 = '#0EC7BA';
export const colorAqua5 = '#00968C';

export const colorGrape1 = '#F8F0FF';
export const colorGrape2 = '#B88ADB';
export const colorGrape3 = '#760FC3';
export const colorGrape4 = '#492F5C';
export const colorGrape5 = '#351D48';

export const colorEggplant = '#683D87';

export const colorRed1 = '#FFE8EE';
export const colorRed2 = '#FF8FAB';
export const colorRed3 = '#FF2158';
export const colorRed4 = '#EE003B';
export const colorRed5 = '#C02048';

export const colorOrange1 = '#FFECE5';
export const colorOrange2 = '#FFA17F';
export const colorOrange3 = '#FF4400';
export const colorOrange4 = '#E73E00';
export const colorOrange5 = '#D33D07';

export const colorYellow1 = '#FFF9E5';
export const colorYellow2 = '#FFE27F';
export const colorYellow3 = '#FFC500';
export const colorYellow4 = '#ECB600';
export const colorYellow5 = '#795E00';

export const colorGreen1 = '#E7F9F3';
export const colorGreen2 = '#87E1C3';
export const colorGreen3 = '#0FC389';
export const colorGreen4 = '#0FB37D';
export const colorGreen5 = '#117D59';

export const colorBlue1 = '#E6F2FA';
export const colorBlue2 = '#86C1E6';
export const colorBlue3 = '#0D83CD';
export const colorBlue4 = '#0C70AE';
export const colorBlue5 = '#095C90';

export const colorDarkblue1 = '#E6ECF7';
export const colorDarkblue2 = '#82A4D7';
export const colorDarkblue3 = '#054AB0';
export const colorDarkblue4 = '#043E94';
export const colorDarkblue5 = '#033175';

export const colorViolet1 = '#F4E7F9';
export const colorViolet2 = '#CB8ADF';
export const colorViolet3 = '#990FC3';
export const colorViolet4 = '#8512A8';
export const colorViolet5 = '#741492';

export const rgbWhite = [255, 255, 255];
export const rgbBlack = [34, 34, 34];

export const rgbGray1 = [248, 248, 248];
export const rgbGray2 = [236, 236, 236];
export const rgbGray3 = [221, 221, 221];
export const rgbGray4 = [204, 204, 204];
export const rgbGray5 = [172, 172, 172];
export const rgbGray6 = [119, 119, 119];
export const rgbGray7 = [97, 97, 97];
export const rgbGray8 = [68, 68, 68];

export const rgbAqua1 = [230, 250, 249];
export const rgbAqua2 = [134, 233, 226];
export const rgbAqua3 = [13, 211, 197];
export const rgbAqua4 = [14, 199, 186];
export const rgbAqua5 = [0, 150, 140];

export const rgbGrape1 = [248, 240, 255];
export const rgbGrape2 = [184, 138, 219];
export const rgbGrape3 = [118, 15, 195];
export const rgbGrape4 = [73, 47, 92];
export const rgbGrape5 = [53, 29, 72];

export const rgbEggplant = [104, 61, 135];

export const rgbRed1 = [255, 232, 238];
export const rgbRed2 = [255, 143, 171];
export const rgbRed3 = [255, 33, 88];
export const rgbRed4 = [238, 0, 59];
export const rgbRed5 = [192, 32, 72];

export const rgbOrange1 = [255, 236, 229];
export const rgbOrange2 = [255, 161, 127];
export const rgbOrange3 = [255, 68, 0];
export const rgbOrange4 = [231, 62, 0];
export const rgbOrange5 = [211, 61, 7];

export const rgbYellow1 = [255, 249, 229];
export const rgbYellow2 = [255, 226, 127];
export const rgbYellow3 = [255, 197, 0];
export const rgbYellow4 = [236, 182, 0];
export const rgbYellow5 = [121, 94, 0];

export const rgbGreen1 = [231, 249, 243];
export const rgbGreen2 = [135, 225, 195];
export const rgbGreen3 = [15, 195, 137];
export const rgbGreen4 = [15, 179, 125];
export const rgbGreen5 = [17, 125, 89];

export const rgbBlue1 = [230, 242, 250];
export const rgbBlue2 = [134, 193, 230];
export const rgbBlue3 = [13, 131, 205];
export const rgbBlue4 = [12, 112, 174];
export const rgbBlue5 = [9, 92, 144];

export const rgbDarkblue1 = [230, 236, 247];
export const rgbDarkblue2 = [130, 164, 215];
export const rgbDarkblue3 = [5, 74, 176];
export const rgbDarkblue4 = [4, 62, 148];
export const rgbDarkblue5 = [3, 49, 117];

export const rgbViolet1 = [244, 231, 249];
export const rgbViolet2 = [203, 138, 223];
export const rgbViolet3 = [153, 15, 195];
export const rgbViolet4 = [133, 18, 168];
export const rgbViolet5 = [116, 20, 146];

export const colorMap = {
  'white': colorWhite,
  'black': colorBlack,

  'gray-1': colorGray1,
  'gray-2': colorGray2,
  'gray-3': colorGray3,
  'gray-4': colorGray4,
  'gray-5': colorGray5,
  'gray-6': colorGray6,
  'gray-7': colorGray7,
  'gray-8': colorGray8,

  'aqua-1': colorAqua1,
  'aqua-2': colorAqua2,
  'aqua-3': colorAqua3,
  'aqua-4': colorAqua4,
  'aqua-5': colorAqua5,

  'grape-1': colorGrape1,
  'grape-2': colorGrape2,
  'grape-3': colorGrape3,
  'grape-4': colorGrape4,
  'grape-5': colorGrape5,

  'eggplant': colorEggplant,

  'red-1': colorRed1,
  'red-2': colorRed2,
  'red-3': colorRed3,
  'red-4': colorRed4,
  'red-5': colorRed5,

  'orange-1': colorOrange1,
  'orange-2': colorOrange2,
  'orange-3': colorOrange3,
  'orange-4': colorOrange4,
  'orange-5': colorOrange5,

  'yellow-1': colorYellow1,
  'yellow-2': colorYellow2,
  'yellow-3': colorYellow3,
  'yellow-4': colorYellow4,
  'yellow-5': colorYellow5,

  'green-1': colorGreen1,
  'green-2': colorGreen2,
  'green-3': colorGreen3,
  'green-4': colorGreen4,
  'green-5': colorGreen5,

  'blue-1': colorBlue1,
  'blue-2': colorBlue2,
  'blue-3': colorBlue3,
  'blue-4': colorBlue4,
  'blue-5': colorBlue5,

  'darkblue-1': colorDarkblue1,
  'darkblue-2': colorDarkblue2,
  'darkblue-3': colorDarkblue3,
  'darkblue-4': colorDarkblue4,
  'darkblue-5': colorDarkblue5,

  'violet-1': colorViolet1,
  'violet-2': colorViolet2,
  'violet-3': colorViolet3,
  'violet-4': colorViolet4,
  'violet-5': colorViolet5,
};

export const rgbMap = {
  'white': rgbWhite,
  'black': rgbBlack,

  'gray-1': rgbGray1,
  'gray-2': rgbGray2,
  'gray-3': rgbGray3,
  'gray-4': rgbGray4,
  'gray-5': rgbGray5,
  'gray-6': rgbGray6,
  'gray-7': rgbGray7,
  'gray-8': rgbGray8,

  'aqua-1': rgbAqua1,
  'aqua-2': rgbAqua2,
  'aqua-3': rgbAqua3,
  'aqua-4': rgbAqua4,
  'aqua-5': rgbAqua5,

  'grape-1': rgbGrape1,
  'grape-2': rgbGrape2,
  'grape-3': rgbGrape3,
  'grape-4': rgbGrape4,
  'grape-5': rgbGrape5,

  'eggplant': rgbEggplant,

  'red-1': rgbRed1,
  'red-2': rgbRed2,
  'red-3': rgbRed3,
  'red-4': rgbRed4,
  'red-5': rgbRed5,

  'orange-1': rgbOrange1,
  'orange-2': rgbOrange2,
  'orange-3': rgbOrange3,
  'orange-4': rgbOrange4,
  'orange-5': rgbOrange5,

  'yellow-1': rgbYellow1,
  'yellow-2': rgbYellow2,
  'yellow-3': rgbYellow3,
  'yellow-4': rgbYellow4,
  'yellow-5': rgbYellow5,

  'green-1': rgbGreen1,
  'green-2': rgbGreen2,
  'green-3': rgbGreen3,
  'green-4': rgbGreen4,
  'green-5': rgbGreen5,

  'blue-1': rgbBlue1,
  'blue-2': rgbBlue2,
  'blue-3': rgbBlue3,
  'blue-4': rgbBlue4,
  'blue-5': rgbBlue5,

  'darkblue-1': rgbDarkblue1,
  'darkblue-2': rgbDarkblue2,
  'darkblue-3': rgbDarkblue3,
  'darkblue-4': rgbDarkblue4,
  'darkblue-5': rgbDarkblue5,

  'violet-1': rgbViolet1,
  'violet-2': rgbViolet2,
  'violet-3': rgbViolet3,
  'violet-4': rgbViolet4,
  'violet-5': rgbViolet5,
};

export const sizeX1 = 4;
export const sizeX2 = 8;
export const sizeX3 = 12;
export const sizeX4 = 16;
export const sizeX5 = 20;
export const sizeX6 = 24;
export const sizeX8 = 32;
export const sizeX10 = 40;
export const sizeX12 = 48;
export const sizeX16 = 64;

export const icons = IconList;

export const fontSizeX1Px = 10;
export const fontSizeX2Px = 13;
export const fontSizeX3Px = 16;
export const fontSizeX4Px = 19;
export const fontSizeX5Px = 25;
export const fontSizeX6Px = 34;
export const fontSizeX7Px = 48;
export const fontSizeX8Px = 66;

export const lineHeightX1Px = 18;
export const lineHeightX2Px = 18;
export const lineHeightX3Px = 24;
export const lineHeightX4Px = 24;
export const lineHeightX5Px = 32;
export const lineHeightX6Px = 40;
export const lineHeightX7Px = 56;
export const lineHeightX8Px = 80;

export const letterSpacingX1Px = 0.1;
export const letterSpacingX2Px = 0.15;
export const letterSpacingX3Px = 0.28;
export const letterSpacingX4Px = 0.6;
export const letterSpacingX5Px = 0.8;

export const transitionDurationFast = 200;
export const transitionDurationBase = 400;
export const transitionDurationSlow = 800;
